<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="ARTÍCULOS" key="1">
          <g-master name="fmo_items"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[8,8]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Nombre del árticulo')">
                    <a-textarea autoSize
                                v-decorator="['item_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="ID ART CATEGORÍA">
                    <a-input
                      v-decorator="['id_item_category', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Comentario')">
                    <a-textarea autoSize
                                v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Compañía')"
                              :formItemConfig="fiOptions"
                              endpoint="company"
                              :decorator="['id_company', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup label="Cuenta"
                            :formItemConfig="fiOptions"
                            endpoint="chart_account"
                            :decorator="['id_chart_account']">
                  </g-lookup>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="IMPUESTOS SOBRE ARTÍCULOS" key="1">
          <items_taxes v-if="idParent" :id_invoice_item="idParent"></items_taxes>
          <span v-else>Seleccione un artículo para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'fmo_items',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre del árticulo', dataIndex: 'item_name', sorter: true},
              {title: 'Compañia', dataIndex: 'company', sorter: true},
              {title: 'Categoría del artículo', dataIndex: 'id_item_category', sorter: true},
              {title: 'Cuenta contable', dataIndex: 'cuenta', sorter: true},
              {title: 'Comentario', dataIndex: 'comments', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'comments'},
            {name: 'id_company'},
            {name: 'id_item_category'},
            {name: 'item_name'},
            {name: 'id_chart_account'}
          ]
        }
      }
    },
    computed: {
      idParent () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/Items.vue